import { Badge, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import { getPartnerDisplayName } from "../../utils/userProfile";

function partnerDisplayName(foreignPartner) {
  const name = getPartnerDisplayName(foreignPartner);
  return name || foreignPartner?.email || "—";
}

function AdminBookingSourceCell({ booking, compact = false }) {
  const { t } = useTranslation("common");

  if (booking?.isAffiliateReservation) {
    const partnerName = partnerDisplayName(booking.foreignPartner);

    if (compact) {
      return (
        <Badge colorScheme="orange" variant="solid" fontSize="xs">
          {t("foreignPartner")}
        </Badge>
      );
    }

    return (
      <VStack align="flex-start" spacing={1}>
        <Badge colorScheme="orange" variant="solid" fontSize="xs">
          {t("foreignPartner")}
        </Badge>
        <Text fontSize="sm" fontWeight="semibold" lineHeight="short">
          {partnerName}
        </Text>
        {booking.foreignPartner?.email && (
          <Text fontSize="xs" color="gray.600" lineHeight="short">
            {booking.foreignPartner.email}
          </Text>
        )}
      </VStack>
    );
  }

  return (
    <Badge colorScheme="gray" variant="subtle" fontSize="xs">
      {t("adminDirectBooking")}
    </Badge>
  );
}

export function adminBookingRowBackground(booking) {
  return booking?.isAffiliateReservation ? "orange.50" : undefined;
}

export default AdminBookingSourceCell;
